module.exports = __webpack_public_path__ + "img/m-sec.38cc4181.jpg";